var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalCandleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m376 0h-240c-24.813 0-45 20.187-45 45v422c0 24.813 20.187 45 45 45h240c24.813 0 45-20.187 45-45v-422c0-24.813-20.187-45-45-45zm-90.811 30-3.932 11.796c-3.63 10.889-13.78 18.204-25.257 18.204s-21.627-7.315-25.256-18.204l-3.932-11.796zm-149.189 0h59.189l7.095 21.283c7.718 23.158 29.306 38.717 53.716 38.717s45.998-15.559 53.717-38.717l7.095-21.283h59.188c8.271 0 15 6.729 15 15v357h-270v-357c0-8.271 6.729-15 15-15zm240 452h-240c-8.271 0-15-6.729-15-15v-35h270v35c0 8.271-6.729 15-15 15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186 362h140c8.284 0 15-6.716 15-15s-6.716-15-15-15h-15v-85c0-12.097-6.171-22.779-15.529-29.068 6.866-13.254 6.68-28.746-.641-41.925l-25.718-46.292c-2.645-4.761-7.665-7.715-13.112-7.715s-10.467 2.954-13.112 7.715l-25.718 46.292c-7.321 13.178-7.508 28.671-.641 41.925-9.358 6.289-15.529 16.971-15.529 29.068v85h-15c-8.284 0-15 6.716-15 15s6.716 15 15 15zm57.395-171.423 12.605-22.69 12.605 22.69c3.615 6.506 1.08 12.179-.177 14.316s-4.985 7.107-12.428 7.107-11.171-4.97-12.428-7.107c-1.258-2.137-3.792-7.81-.177-14.316zm-12.395 56.423c0-2.757 2.243-5 5-5h40c2.757 0 5 2.243 5 5v85h-50z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalCandleIcon);
export default __webpack_public_path__ + "static/media/digitalCandleIcon.f323485f2859f356c9c50f31fa8ee7ae.svg";
export { ForwardRef as ReactComponent };